import MHCError from '../utils/MHCError';
import CustomFormData from '../utils/CustomFormData';
import axios from 'axios';
//import FlurryAnalytics from 'react-native-flurry-analytics';

import {store} from '../utils/configureStore';
import history from '../utils/configureRouteHistory';
import {REST_ERROR_CODE} from '../constants';
import {resetUserData, showOTPModal} from './'
// export const MHC_BASE = 'https://staging-incomeapp.mhc.asia' //staging
// export const MHC_BASE_URL = MHC_BASE + '/api/v1'; //mhc
const MHC_BASE_URL = process.env.REACT_APP_API_ROOT_URL + '/externalapi';

export const STRING_X_APP_ID_VALUE = "qGNj1cCRdVg7izFVajV125LWhIrbIkIC"; //<===== please change this when clone
export const STRING_X_APP_KEY_VALUE = "N7QdgG79Lllsc2EJNQm9V0RDNJbH5Sie"; //<===== please change this when clone

export const PRODUCTS_LIST_REQUEST = 'PRODUCTS_LIST_REQUEST';
export const PRODUCTS_LIST_SUCCESS = 'PRODUCTS_LIST_SUCCESS';
export const PRODUCTS_LIST_FAILURE = 'PRODUCTS_LIST_FAILURE';
export const PURCHASED_PRODUCTS_LIST_REQUEST = 'PURCHASED_PURCHASED_PRODUCTS_LIST_REQUEST';
export const PURCHASED_PRODUCTS_LIST_SUCCESS = 'PURCHASED_PRODUCTS_LIST_SUCCESS';
export const PURCHASED_PRODUCTS_LIST_FAILURE = 'PURCHASED_PRODUCTS_LIST_FAILURE';
export const PRODUCTS_REDEEM_REQUEST = 'PRODUCTS_REDEEM_REQUEST';
export const PRODUCTS_REDEEM_SUCCESS = 'PRODUCTS_REDEEM_SUCCESS';
export const PRODUCTS_REDEEM_FAILURE = 'PRODUCTS_REDEEM_FAILURE';
export const PRODUCTS_BUY_REQUEST = 'PRODUCTS_BUY_REQUEST';
export const PRODUCTS_BUY_SUCCESS = 'PRODUCTS_BUY_SUCCESS';
export const PRODUCTS_BUY_FAILURE = 'PRODUCTS_BUY_FAILURE';
// Generate Incoice
export const GENERATE_INVOICE_REQUEST = "GENERATE_INVOICE_REQUEST";
export const GENERATE_INVOICE_SUCCESS = "GENERATE_INVOICE_SUCCESS";
export const GENERATE_INVOICE_FAILURE = "GENERATE_INVOICE_FAILURE";
const FETCH_EXCEPTION_ERROR_MSG = 'Sorry, there seems to be an issue with the network. Please try again later.'
const className = 'productsActions'

// Add a response interceptor to axios to return the errorMessage from API instead of error object
// axios.interceptors.response.use(function (response) {
//     return response;
// }, function (error) {
//     console.log(error)
//     if (error.response && error.response.status && error.response.status === 401) {

//         // if response tell expired, locked, suspended, or terminated, reset user data and redirect to login page
//         if(error.response.data && (
//             error.response.data.errorCode === REST_ERROR_CODE.TOKEN_EXPIRED ||
//             error.response.data.errorCode === REST_ERROR_CODE.ACCOUNT_LOCKED ||
//             error.response.data.errorCode === REST_ERROR_CODE.ACCOUNT_SUSPENDED ||
//             error.response.data.errorCode === REST_ERROR_CODE.ACCOUNT_TERMINATED
//         )){
//             if(history.location.pathname !== '/'){
//                 store.dispatch(resetUserData());
//                 history.push(`/?redirect=${window.location.pathname}&info=${error.response.data.errorMessage}`);
//             }
//         }

//         return Promise.reject({errorCode: 401, errorMessage: 'Unauthorized Access or Token has Expired'});
//     } else if (error.response && error.response.status && error.response.status === 428) {
//         store.dispatch(showOTPModal());
//         return Promise.reject({errorCode: 428, errorMessage: 'Your account need verification. If you have any questions, please email us at groupcare@mhcasiagroup.com or call us at +65 63054573.'});
//     } else {
//         if (error.response) {
//             return Promise.reject({errorCode: error.response.status, errorMessage: (error.response.data && error.response.data.errorMessage) ? error.response.data.errorMessage : 'Something went wrong.'});
//         } else {
//             return Promise.reject({errorCode: error.response.status, errorMessage: error});
//         }
//     }
// });

export function productsListRequest() {
    return {
        type: PRODUCTS_LIST_REQUEST
    };
}

export function productsListSuccess(products) {
    return {
        type: PRODUCTS_LIST_SUCCESS,
        payload: products
    };
}

export function productsListFailure(error) {
    return {
        type: PRODUCTS_LIST_FAILURE,
        error
    };
}


export function purchasedProductsListRequest() {
    return {
        type: PURCHASED_PRODUCTS_LIST_REQUEST
    };
}

export function purchasedProductsListSuccess(purchased_products) {
    return {
        type: PURCHASED_PRODUCTS_LIST_SUCCESS,
        purchased_products
    };
}

export function purchasedProductsListFailure(error) {
    return {
        type: PURCHASED_PRODUCTS_LIST_FAILURE,
        error
    };
}


export function productsRedeemRequest() {
    return {
        type: PRODUCTS_REDEEM_REQUEST
    };
}

export function productsRedeemSuccess(purchased_product) {
    return {
        type: PRODUCTS_REDEEM_SUCCESS,
        purchased_product
    };
}

export function productsRedeemFailure(error) {
    return {
        type: PRODUCTS_REDEEM_FAILURE,
        error
    };
}

export function productsBuyRequest() {
    return {
        type: PRODUCTS_BUY_REQUEST
    };
}

export function productsBuySuccess(purchased_product) {
    return {
        type: PRODUCTS_BUY_SUCCESS,
        purchased_product
    };
}

export function productsBuyFailure(error) {
    return {
        type: PRODUCTS_BUY_FAILURE,
        error
    };
}

export function generateInvoiceRequest() {
    return {
        type: GENERATE_INVOICE_REQUEST
    };
  }
  
  export function generateInvoiceSuccess(invoice) {
    return {
        type: GENERATE_INVOICE_SUCCESS,
        invoice
    };
  }
  
  export function generateInvoiceFailure(error) {
    return {
        type: GENERATE_INVOICE_FAILURE,
        error
    };
  }

export function productsListAction(startDate, endDate) {
    return (dispatch, getState) => {
        dispatch(productsListRequest());
        let url = MHC_BASE_URL + '/products';
        console.log(url);
        console.log({
            'Accesstoken': getState().user.user.accessToken,
        })
        return axios({ 
            method: 'GET',
            url,
            data: {},
            headers: {
                'Accesstoken': getState().user.user.accessToken,
            }

        }).then((response) => {
            console.log(response)
            dispatch(productsListSuccess(response.data));
        }).catch((error) => {
            console.log('Response Error');
            dispatch(productsListFailure(error));
        });
    };
}

export function purchasedProductsListAction(startDate, endDate) {
    return (dispatch, getState) => {
        dispatch(purchasedProductsListRequest());
        let url = MHC_BASE_URL + '/products/purchased_list/' + getState().user.user.uuid;
        return axios({ 
            method: 'GET',
            url,
            data: {},
            headers: {
                'Accesstoken': getState().user.user.accessToken,
            }

        }).then((response) => {
            console.log(response)
            dispatch(purchasedProductsListSuccess(response.data.purchased_products));
        }).catch((error) => {
            console.log('Response Error', error);
            dispatch(purchasedProductsListFailure(error));
        });
    };
}
// export function purchasedProductsListAction(startDate, endDate) {
//     return (dispatch, getState) => {
//         dispatch(purchasedProductsListRequest());

//         let urlString = MHC_BASE_URL + '/products/purchased_list/' + getState().user.user.uuid;
//         console.log(urlString);

//         return fetch(urlString, {
//             method: 'GET',

//         }).then(response => {
//             if (response.ok) {
//                 console.log('Response Success');
//                 return response.json().then(json => {
//                     dispatch(purchasedProductsListSuccess(json['purchased_products']));
//                 });
//             } else {
//                 console.log('Response Error');
//                 let mhcError = new MHCError();
//                 return mhcError.setResponse(response, 'List Purchased Products Failed').then(() => {
//                 dispatch(purchasedProductsListFailure(mhcError));
//             });
//         }

//         }).catch(error => {
//             console.log('Parse Error:', error);
//             let mhcError = new MHCError(500, FETCH_EXCEPTION_ERROR_MSG, 'List Purchased Products Failed');
//             dispatch(purchasedProductsListFailure(mhcError));
//         });
//     };
// }


export function productsRedeemAction(uuid, redeemCode) {
    return (dispatch, getState) => {
        dispatch(productsRedeemRequest());

        let urlString = MHC_BASE_URL + '/products/purchased/' + uuid + '/' + getState().user.user.uuid + '/redeem';
        console.log(urlString);

        return fetch(urlString, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'AccessToken': getState().user.user.accessToken
            },
            body: CustomFormData.jsonString({
                redeemCode: redeemCode
            })
        }).then(response => {
            if (response.ok) {
                console.log('Response Success');
                return response.json().then(json => {
                    dispatch(productsRedeemSuccess(json['purchased_product']));
                });
            } else {
                console.log('Response Error');
                let mhcError = new MHCError();
                return mhcError.setResponse(response, 'Redeem Product Failed').then(() => {
                    dispatch(productsRedeemFailure(mhcError));
                });
        }

        }).catch(error => {
            console.log('Parse Error:', error);
            let mhcError = new MHCError(500, FETCH_EXCEPTION_ERROR_MSG, 'Redeem Product Failed');
            dispatch(productsRedeemFailure(mhcError));
        });
    };
}

export function productsBuyAction(uuid, quantity) {
    return (dispatch, getState) => {
        dispatch(productsBuyRequest());

        let urlString = MHC_BASE_URL + '/products/' + uuid + '/buy';
        console.log(urlString);

        return fetch(urlString, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'AccessToken': getState().user.user.accessToken
            },
            body: CustomFormData.jsonString({
                quantity: quantity,
                stripeCustomerID: getState().user.user.stripeCustomerId,
                userUUID: getState().user.user.uuid
            })
        }).then(response => {
            if (response.ok) {
                console.log('Response Success');
                return response.json().then(json => {
                    dispatch(productsBuySuccess(json['purchased_product']));
                });
            } else {
                console.log('Response Error');
                let mhcError = new MHCError();
                return mhcError.setResponse(response, 'Buy Product Failed').then(() => {
                    dispatch(productsBuyFailure(mhcError));
                });
            }

        }).catch(error => {
            console.log('Parse Error:', error);
            let mhcError = new MHCError(500, FETCH_EXCEPTION_ERROR_MSG, 'Buy Product Failed');
            dispatch(productsBuyFailure(mhcError));
        });
    };
}

export function generateInvoice(uuid, userUUID) { 
    return (dispatch, getState) => {
        dispatch(generateInvoiceRequest()); 
        // MHC_BASE_URL + '/products/' + uuid + '/buy';
        let urlString = MHC_BASE_URL + `/products/invoice/${uuid}/${userUUID}`;
        console.log(urlString);
        let user = getState().user.user 
        return fetch(urlString, {
            method: 'GET',
            headers: {
                'AccessToken': user.accessToken,
                'Content-Type': 'application/pdf', 
            }, 
        }).then(response => { 
            if (response.ok) { 
                return response.json().then(json => {    
                    dispatch(generateInvoiceSuccess(json['invoice']));
                });
            } else {
                // LogFetchResponseError(arguments.callee, response);
                console.log('Response Error');
                let mhcError = new MHCError();
                return mhcError.setResponse(response, 'Generate Invoice Unsuccessful').then(() => { 
                dispatch(generateInvoiceFailure(mhcError));
            });
        }
  
        }).catch(error => { 
            let mhcError = new MHCError(500, FETCH_EXCEPTION_ERROR_MSG, 'Generate Invoice Unsuccessful'); 
            dispatch(generateInvoiceFailure(mhcError));
        });
    };
  }